export default "__VITE_ASSET__75bb1cbc__"